import apiService from '../apiService';

/** 發放紀錄（跨會員，不需先選會員） */
export const getInventoryGrants = (params = {}) =>
    apiService.GET('/api/admin/inventory-grants', params);

export const getUserInventory = (userId, params = {}) =>
    apiService.GET(`/api/admin/users/${userId}/inventory`, params);

export const getUserInventoryItem = (id) =>
    apiService.GET(`/api/admin/user-inventory/${id}`);

export const grantUserInventory = (userId, data) =>
    apiService.POST(`/api/admin/users/${userId}/inventory/grant`, data);

export const updateUserInventoryItem = (id, data) =>
    apiService.PUT(`/api/admin/user-inventory/${id}`, data);

export const deleteUserInventoryItem = (id) =>
    apiService.DELETE(`/api/admin/user-inventory/${id}`);

export const getUserInventoryLogs = (id) =>
    apiService.GET(`/api/admin/user-inventory/${id}/logs`);

export const transferUserInventoryItem = (id, data) =>
    apiService.POST(`/api/admin/user-inventory/${id}/transfer`, data);
